import { Lock, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

interface Props {
  status: 'coming_soon' | 'maintenance' | 'hidden';
}

export default function ModuleLockedState({ status }: Props) {
  const [, setLocation] = useLocation();

  if (status === 'hidden') {
    return null;
  }

  const isMaintenance = status === 'maintenance';
  const Icon = isMaintenance ? Wrench : Lock;
  const title = isMaintenance ? "Making Updates" : "Coming Soon";
  const desc = isMaintenance 
    ? "We are currently making updates to this section. It is temporarily unavailable."
    : "This section is currently locked and will be available soon!";

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6 bg-card p-8 rounded-2xl border shadow-sm">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
          <Icon className="h-8 w-8 text-primary" />
        </div>
        <div>
          <h1 className="text-3xl font-bold font-serif mb-2">{title}</h1>
          <p className="text-muted-foreground">{desc}</p>
        </div>
        <Button onClick={() => setLocation("/")} className="mt-4">
          Return to Dashboard
        </Button>
      </div>
    </div>
  );
}
